import { Inject, Injectable, NgZone } from '@angular/core'
import { DepartmentMapFilterService } from './department-map-filter.service'
import { MapColorGeneratorService } from '../../../../../features/map/services/map-color-generator.service'
import { IFilterDefTypeEnum } from '../../../../../shared/open-layers/layer-filter.interface'
import { ParcelGroupDto } from '../../../../../api/backend'
import { MapColorGeneratorActions } from '../../../../../features/map/common/map-color-generator/state/action-types'
import { Store } from '@ngrx/store'
import { selectMapColorGeneratorColorMapByKey } from '../../../../../features/map/common/map-color-generator/state/map-color-generator.selectors'
import { filter, take } from 'rxjs/operators'

@Injectable({
    providedIn: 'root'
})
export class GeneralMapLayerDefinitionsParcelGroupService {
    colorList = {}

    constructor(
        @Inject(Store) private store: Store,
        @Inject(NgZone) private ngZone: NgZone,
        @Inject(DepartmentMapFilterService) private departmentMapFilterService: DepartmentMapFilterService,
        @Inject(MapColorGeneratorService) private mapColorGeneratorService: MapColorGeneratorService,
    ) {
    }

    public getLayers(parcelGroups: Array<ParcelGroupDto>): Promise<any> {
        return new Promise<any>(resolve => {
            const layers = []

            if (parcelGroups?.length) {
                this.initColorList(parcelGroups).then(() => {
                    parcelGroups.forEach(parcelGroup => {
                        const color = this.colorList[parcelGroup.id]
                        const layer = {
                            id: 'parcel_group_' + parcelGroup.id,
                            type: 'wms',
                            title: parcelGroup.name,
                            selector: 'switch',
                            visible: false,
                            selectorStyle: 'custom-icon-color',
                            styleAttribute: this.mapColorGeneratorService.getMapLayerIconStyle(color.fill, color.stroke)
                        }

                        layers.push(layer)
                    })
                    resolve(layers.reverse())
                })
            } else {
                resolve(layers)
            }
        })
    }

    public getParcelGroupLayer(id, url, layerPrefix): any {
        const c = this.mapColorGeneratorService.getHexColor(this.colorList[id].mapColor)
        return {
            id: 'parcel_group_' + id,
            layer: {
                type: 'wms',
                url: url,
                reload: true,
                wms: {
                    layers: layerPrefix + 'parcel_group',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 360
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'parcel_group_id',
                    literal: id
                }),
                sldBody: {
                    name: layerPrefix + 'parcel_group',
                    rules: [
                        {
                            name: 'parcel_group_' + id,
                            polygonSymbolizer: {
                                fill: {
                                    svgParameter: {
                                        'fill': c,
                                        'fill-opacity': this.colorList[id].mapOpacity
                                    }
                                },
                                stroke: {
                                    svgParameter: {
                                        'stroke': c,
                                        'stroke-width': 1
                                    }
                                }
                            }
                        }
                    ]
                }
            }
        }
    }

    // ---------

    private initColorList(parcelGroups: Array<ParcelGroupDto>): Promise<void> {
        return new Promise(resolve => {
            this.ngZone.run(() => {
                this.store.dispatch(MapColorGeneratorActions.getNextColors({ num: parcelGroups.length, ident: 'parcel_group' }))

                this.store.select(selectMapColorGeneratorColorMapByKey('parcel_group')).pipe(
                    filter((colors: any[]) => colors && colors.length > 0),
                    take(1)
                ).subscribe(colors => {
                    for (let i = 0; i < parcelGroups.length; i++) {
                        this.colorList[parcelGroups[i].id] = colors[parcelGroups.length - i - 1]
                    }
                    resolve()
                })
            })
        })
    }
}